export default __webpack_public_path__ + "static/media/php.243a5960.svg";